

const builderOptions = (data = [], label) => {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
        value: item.id,
        label: label(item),
        raw: item,
    }))
}

// Elementos

export const stockOptions = (data = []) => {
    // elementos, repuestos, herramientas, etc
    const label = (item) => `${item.id} - ${item.label} ${item.detalle ? " | " + item.detalle : ""}`;
    return builderOptions(data, label);
};

export const proveedoresOptions = (data = []) => {
    // proveedores de articulos y servicios
    const label = (item) => `${item.id} - ${item.nombre} ${item.marca !== item.nombre ? "(" + item.marca + ")" : ""} - ${item.cuit !== 0 && item.cuit}`
    return builderOptions(data, label);
}

export const empresasOptions = (data = []) => {
    // empresas, proveedores y sucursales
    const label = (item) => `${item.nombre} (${item.id})`;
    return builderOptions(data, label)
};

export const personasOptions = (data = []) => {
    // personas(full), mecanicos, choferes, etc
    const label = (item) => `${item.apellido}, ${item.nombres} ${item.especializacion ? "(" + item.especializacion + ")" : item.puesto ? "(" + item.puesto + ")" : ""}`;
    return builderOptions(data, label)
};

export const vehiculosOptions = (data = []) => {
    // tractores, furgones y vehiculos
    const label = (item) => `${item.id} (${item.dominio === item.id ? item.marca : item.dominio})`;
    return builderOptions(data, label)
};

export const sectoresOptions = (data = []) => {
    const label = (item) => `${item.id} - ${item.nombre}`;
    return builderOptions(data, label);
};

// Tipos

export const llavesOptions = () => {
    return [
        { value: "RETIRA", label: "RETIRA LLAVES" },
        { value: "ENTREGA", label: "ENTREGA LLAVES" },
    ];
};

export const porteriaOptions = (filtro = null) => {
    if (filtro === "llaves") {
        return llavesOptions();
    }
    return [
        { value: "ENTRADA", label: "ENTRADA AL PREDIO" },
        { value: "SALIDA", label: "SALIDA DEL PREDIO" },
    ];
};

export const satelitalOptions = () => {
    return [
        { value: "ACCIDENTE", label: "ACCIDENTE" },
        { value: "ALARMA", label: "ALARMA" },
        { value: "AUXILIO", label: "AUXILIO" },
        { value: "CAMBIO", label: "CAMBIO" },
        { value: "CONVOY", label: "CONVOY" },
        { value: "CORTE", label: "CORTE DE COMBUSTIBLE" },
        { value: "ROBO", label: "ROBO" },
        { value: "ROTURA", label: "ROTURA" },
        { value: "SATELITAL", label: "SATELITAL" },
    ]
}

export const tractoresOptions = (filtro = null) => {
    if (filtro === "llaves") {
        return llavesOptions();
    }
    return [
        { value: "CAMBIO", label: "CAMBIO" },
        { value: "REVISION", label: "REVISION" },
        { value: "SERVICE", label: "SERVICE" },
        { value: "ALINEACION Y BALANCEO", label: "ALINEACION Y BALANCEO" },
    ];
};

export const furgonesOptions = () => {
    return [
        { value: "CAMBIO", label: "CAMBIO" },
        { value: "REVISION", label: "REVISION" },
        { value: "SERVICE", label: "SERVICE" },
    ];
}

export const stockTypeOptions = () => {
    return {
        "AC": { "tipo": "ACCESORIO", "descripcion": "COMPONENTES ADICIONALES O DECORATIVOS DEL VEHÍCULO" },
        "CA": { "tipo": "CARROCERIA", "descripcion": "PARTES EXTERNAS Y ESTRUCTURALES DEL CAMIÓN" },
        "CB": { "tipo": "COMBUSTIBLE", "descripcion": "ELEMENTOS DEL SISTEMA DE ALIMENTACIÓN Y FILTRADO DE COMBUSTIBLE" },
        "EL": { "tipo": "ELECTRICIDAD", "descripcion": "SISTEMA ELÉCTRICO, ILUMINACIÓN Y SENSORES" },
        "FL": { "tipo": "FLUIDO", "descripcion": "ACEITES, GRASAS Y TODO LÍQUIDO DESTINADO AL MANTENIMIENTO/FUNCIONAMIENTO DEL VEHÍCULO." },
        "FR": { "tipo": "FRENOS", "descripcion": "COMPONENTES DEL SISTEMA DE FRENOS Y AIRE" },
        "HI": { "tipo": "HIDRAULICA", "descripcion": "SISTEMAS HIDRÁULICOS Y NEUMÁTICOS AUXILIARES" },
        "HE": { "tipo": "HERRAMIENTA", "descripcion": "TODO TIPO DE ELEMENTOS, UTENSILIOS Y EQUIPOS UTILIZADOS PARA EL MANTENIMIENTO, REPARACIÓN O AJUSTE DE LOS VEHÍCULOS" },
        "IN": { "tipo": "INSUMO", "descripcion": "MATERIALES Y PRODUCTOS DE USO RECURRENTE EN TAREAS DE MANTENIMIENTO, LIMPIEZA O REPARACIÓN DE LOS VEHÍCULOS" },
        "MT": { "tipo": "MOTOR", "descripcion": "PARTES Y ACCESORIOS DEL MOTOR" },
        "RC": { "tipo": "RECUPERADO", "descripcion": "COMPONENTE, ELEMENTO, PARTE O ACCESORIO TOMADO DE UN VEHICULO PARA USAR EN OTRO." },
        "RF": { "tipo": "REFRIGERACION", "descripcion": "SISTEMA DE ENFRIAMIENTO DEL MOTOR Y RADIADORES" },
        "RO": { "tipo": "RODADO", "descripcion": "RUEDAS, CUBIERTAS, LLANTAS Y RODAMIENTOS" },
        "SP": { "tipo": "SUSPENSION", "descripcion": "AMORTIGUADORES, BUJES, FUELLES Y RESORTES" },
        "TR": { "tipo": "TRANSMISION", "descripcion": "EMBRAGUE, CAJA DE CAMBIOS Y DIFERENCIAL" },
        "SV": { "tipo": "SERVICIO", "descripcion": "TAREAS DE MANTENIMIENTO, REVISIÓN, DIAGNÓSTICO O INTERVENCIÓN REALIZADAS SOBRE EL VEHÍCULO" }
    };
}

export const unidadesOptions = () => {
    return {
        "UN": { "descripcion": "UNIDADES" },
        "LT": { "descripcion": "LITROS" },
        "MT": { "descripcion": "METROS" },
        "KG": { "descripcion": "KILOGRAMOS" },
        "GR": { "descripcion": "GRAMOS" },
        "ML": { "descripcion": "METROS LINEALES" },
        "CM": { "descripcion": "CENTIMETROS" },
        "MM": { "descripcion": "MILIMETROS" },
        "RL": { "descripcion": "ROLLOS" },
        "M3": { "descripcion": "METROS CUBICOS" },
        "TN": { "descripcion": "TONELADAS" }
    }
}

export const puestosOptions = () => {
    return {
        "ADMINISTRATIVO": { key: "ADMINISTRATIVO", "descripcion": "ADMINISTRATIVO" },
        "CHOFER": { key: "CHOFER", "descripcion": "CHOFER (LARGA / MOVIMIENTO)" },
        "MAESTRANZA": { key: "MAESTRANZA", "descripcion": "PERSONAL DE MAESTRANZA" },
        "TALLER": { key: "TALLER", "descripcion": "TALLER (MECANICOS, ELECTRICISTAS, GOMEROS, ETC)" },
        "TRAFICO": { key: "TRAFICO", "descripcion": "PERSONAL DE TRÁFICO" },
        "MANTENIMIENTO": { key: "MANTENIMIENTO", "descripcion": "PERSONAL DE MANTENIMIENTO" },
    }
}

export const especializacionesOptions = (puesto) => {
    switch (puesto) {
        case "ADMINISTRATIVO":
            return [
                { value: "RRHH", label: "RECURSOS HUMANOS" },
                { value: "CONTABLE", label: "CONTABLE" },
                { value: "FACTURACION", label: "FACTURACIÓN" },
                { value: "COMPRAS", label: "COMPRAS" },
                { value: "TRAFICO", label: "TRAFICO" },
                { value: "SATELITAL", lable: "SATELITAL" },
            ];

        case "CHOFER":
            return [
                { value: "LARGA DISTANCIA", label: "LARGA DISTANCIA" },
                { value: "MOVIMIENTO", label: "MOVIMIENTO" },
            ];
        case "MAESTRANZA":
            return [
                { value: "LIMPIEZA", label: "LIMPIEZA" },
            ];
        /* ── EL OFICIO DEL TALLER SE CARGA EN EL TALLER ──────────────────
         *
         * Acá se ofrecían MECANICO / ELECTRICISTA / GOMERO. Se movieron al
         * padrón de mecánicos de la ticketera de FlotaBot, que es donde Pablo
         * da de alta y de baja y de donde sale el desplegable al asignar una
         * reparación. Lo pidió él: "solo es que estén ingresados y asignar
         * mecánico desde una lista".
         *
         * DEJARLAS EN LOS DOS LADOS SERÍA EL PROBLEMA. Serían dos lugares
         * donde decir el mismo oficio, y el día que difieran nadie sabría cuál
         * manda — con el agravante de que el desplegable de la ticketera se
         * arma con uno solo de los dos, así que la otra mitad se cargaría
         * "bien" y no aparecería en ningún lado. Es la lección de los dos
         * talleres del hub.
         *
         * Y LA LISTA ESTABA INCOMPLETA, que es lo que lo destapó: ofrecía tres
         * y en los datos hay DIECISIETE valores distintos. FURGONERO lo
         * escribieron 7 personas —en dos grafías— porque la opción no existía.
         * Lo que no se ofrece se tipea, y después no se puede agrupar.
         *
         * LO YA CARGADO NO SE TOCA. Las 21 personas con MECANICO en
         * `especializacion` la conservan: esto deja de OFRECER la opción, no
         * la borra. Sacarles el dato dejaría el padrón de personal peor de lo
         * que estaba por una mudanza que no era sobre ellos.
         */
        case "TALLER":
            return [];
        case "TRAFICO":
            return [
                { value: "LOGISTICA", label: "LOGISTICA" },
                { value: "COMBUSTIBLE", label: "CONTROL DE COMBUSTIBLE" },
                { value: "DOCUMENTACION", label: "CONTROL DE DOCUMENTACION" },
            ];
        case "MANTENIMIENTO":
            return [
                { value: "GENERAL", label: "MANTENIMIENTO GENERAL DEL PREDIO" },
            ];
        default:
            return [];
    }
};

/* EL VÍNCULO CON LA EMPRESA, NO EL OFICIO.
 *
 * Igna, mirando el alta (28/08/2026): *«En "Tipo" falta (por ejemplo)
 * mecánico, dice "Empleado (TC-TA-EX)" pero no dice qué tipo de empleado»*.
 *
 * Tenía razón en el síntoma y el campo no es el que parecía: acá se dice si la
 * persona está EN RELACIÓN DE DEPENDENCIA o no, y el oficio se dice en
 * «Puesto», el campo de abajo. Lo que estaba mal era el nombre —«Tipo» a
 * secas— y que la etiqueta nombrara tres de las cuatro empresas propias, que
 * es lo que hacía leer la lista como si ahí fuera el puesto.
 *
 * Se arregla el nombre y el texto. Las CLAVES no se tocan: son las que hay
 * guardadas en `personas.tipo` y renombrarlas dejaría al padrón entero
 * apuntando a opciones que ya no existen. */
export const tipoEmpleadoOptions = () => {
    return {
        "EMPLEADO": { "key": "EMPLEADO", "descripcion": "En relación de dependencia (TA · TC · EX · TCC)" },
        "PROVEEDOR": { "key": "PROVEEDOR", "descripcion": "Proveedor" },
        "EXTERNO": { "key": "EXTERNO", "descripcion": "Externo (fleteros, contratistas)" },
    }
}

export const reparacionesTractoresOptions = () => {
    return [
        { value: "REPARACION", label: "REPARACION" },
        { value: "CAMBIO", label: "CAMBIO" },
        { value: "REVISION", label: "REVISION" },
        { value: "SERVICE", label: "SERVICE" },
        { value: "ALINEACION Y BALANCEO", label: "ALINEACION Y BALANCEO" },
    ];
}